import type { RoadmapKey } from '@/shared/config'
import { roadmapEntry } from '@/shared/config'
import { cn } from '@/shared/lib/cn'
import s from './RoadmapBadge.module.css'

type RoadmapBadgeProps = {
  /**
   * Ключ реестра, а не готовая подпись. Так бейдж физически не может разойтись с
   * `shared/config/roadmap.ts`: реализуют возможность — строку оттуда удалят, `RoadmapKey`
   * перестанет знать этот ключ, и **сборка упадёт у каждого потребителя разом**. Заглушку,
   * которую забыли снять, ловит компилятор, а не следующее ревью.
   *
   * Подпись бейджа берётся из реестра (`не реализовано` / `скоро` / `не работает`), а не из пропа:
   * два источника истины о готовности одной фичи однажды разошлись бы, и разошёлся бы тот, о
   * котором забыли.
   */
  roadmapKey: RoadmapKey
  className?: string
}

/**
 * «не реализовано» · «скоро» · «не работает» — видимая половина механизма roadmap.
 *
 * **Живёт в `shared/ui`, а не рядом с первым потребителем, ровно по той причине, по которой сам
 * реестр живёт в одном файле:** бейджи рассыпаны по всему макету (детали брони — фаза 2; факты
 * условий и шаг «Документы» — фаза 5; SMS-канал — фаза 7; вид задачи — фаза 4), и своя копия
 * бейджа в каждой фазе означала бы, что снимать их придётся по всему коду — и что-нибудь
 * обязательно осталось бы. Реестр и его отрисовка — одна вещь, разнесённая по двум слоям.
 *
 * Поле `note` реестра здесь НЕ показывается: в макете у бейджа нет ни подсказки, ни второй строки,
 * а дорисовывать их «на будущее» — значит дорисовывать дизайн (HANDOFF §5). Появится место, где
 * `note` нужен, — там он и появится, у своего потребителя.
 */
export function RoadmapBadge({ roadmapKey, className }: RoadmapBadgeProps) {
  return <span className={cn(s.root, className)}>{roadmapEntry(roadmapKey).badge}</span>
}
